import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild, AfterViewInit, AfterContentChecked, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { DhlFormControlEventData } from 'src/app/common/models/dhl-form-control-event-data';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';

@Component({
    selector: 'app-form-field-dropdown-multi-choice-v2',
    templateUrl: './form-field-dropdown-multi-choice-v2.component.html',
    styleUrls: ['./form-field-dropdown-multi-choice-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldDropdownMultiChoiceV2Component implements OnInit, AfterViewInit, AfterContentChecked {

  @Input() configData;
  @Input() frmGroup: UntypedFormGroup;

  focusedOption: number = -1;
  placeHolderText = "";
  selectAllText = "all";
  comma = ",";
  selectedValues = "";
  dropIsClosed = true;
  selectedOpt: any;
  sortAsc = true;
  checkboxAllStatus = false;
  showDropSelect = false;
  disabled: boolean = false;
  clickedInsideComponent: boolean = false;
  dropdownArrayValue = [];

  @ViewChild('dropdown',{static: true, read: ElementRef}) dropdown: ElementRef;
  @ViewChild('dropdownselect',{static: true, read: ElementRef}) dropdownselect: ElementRef;
  @ViewChild('dropselect',{static: true, read: ElementRef}) dropselect: ElementRef;
  @ViewChild('droplabel',{static: true, read: ElementRef}) droplabel: ElementRef;
  @ViewChild('dropIcon',{static: true, read: ElementRef}) dropIcon: ElementRef;
  @ViewChild('options',{static: true, read: ElementRef}) options: ElementRef;
  @ViewChild('dropdownouter',{static: true, read: ElementRef}) dropdownouter: ElementRef;
  @ViewChild('sortIcon',{static: true, read: ElementRef}) sortIcon: ElementRef;
  @ViewChild('select',{static: true, read: ElementRef}) select: ElementRef;

  get getSelectAllTxt() {
    return this.selectAllText;
  }

  constructor(private renderer: Renderer2, private appService: AppService) {
  }

  isClickInsideComponent(element, classname) {
    if (element && element.className && element.className.split(' ').indexOf(classname) >= 0 && element.id == this.configData.name) return true;
    return element.parentNode && this.isClickInsideComponent(element.parentNode, classname);
  }

  ngOnInit() {
    this.disabled = this.configData.disabled;
    this.selectedValues = this.configData.placeholder;
    if (this.configData.disabled) {
      this.frmGroup.get(this.configData.name)['required'] = false;
      this.configData.required = false;
    }

    this.renderer.listen('window', 'click', (e: Event) => {
      this.clickedInsideComponent = this.isClickInsideComponent(e.target, 'dhl-dropdown');
      if (!this.clickedInsideComponent || ((this.dropselect && e.target !== this.dropselect.nativeElement) && (this.droplabel && e.target !== this.droplabel.nativeElement) &&
        e.target !== this.dropdown.nativeElement && e.target !== this.dropdownselect.nativeElement &&
        e.target !== this.options.nativeElement && (this.dropIcon && e.target !== this.dropIcon.nativeElement) &&
        e.target !== this.dropdownouter.nativeElement && (this.sortIcon && e.target !== this.sortIcon.nativeElement))) {
        this.focusout();
      }
    });
    this.placeHolderText = this.configData.placeholder;
    this.fieldValueValidation(this.configData.validation);
  }

  toggleDisable(bool) {
    this.disabled = bool;
  }

  ngAfterViewInit() {
    if (Object.keys(this.configData.defaultValue).length > 0) {
      this.selectedOption( this.configData.defaultValue, true);
    }else if(this.frmGroup.get(this.configData.name).value.length > 0){
      this.selectedOption(this.frmGroup.get(this.configData.name).value, true);
    }

    this.frmGroup.get(this.configData.name).statusChanges.subscribe(x => {
      if (this.frmGroup.get(this.configData.name).value == undefined) {
        this.dropdown.nativeElement.classList.remove('filled');
      } else {
        this.frmGroup.get(this.configData.name).markAsDirty();
      }
    });
    if(this.dropselect){
      this.dropselect.nativeElement.style.width = this.dropdownselect.nativeElement.offsetWidth + "px";
    }
  }

  ngAfterContentChecked() {
    if (!this.dropIsClosed) {
      this.positionDrop();
    }
  }

  toggleDrop(target) {
    if (target.classList.value.indexOf('sort-icon') == -1 || 
        (target.classList.value.indexOf('sort-icon') > -1 && this.dropIsClosed)) {
      this.dropIsClosed = !this.dropIsClosed;
      if (this.sortIcon && this.dropIsClosed) {
        this.dropdown.nativeElement.classList.remove('focus');
        if(this.dropIcon){
          this.dropIcon.nativeElement.classList.replace('open', 'closed');
        }
        if (this.configData.sortable) {
          this.sortIcon.nativeElement.classList.replace('default', 'filled');
        }
      } else {
        this.dropdown.nativeElement.classList.add('focus');
        if(this.dropIcon){
          this.dropIcon.nativeElement.classList.replace('closed', 'open');
        }
        this.dropdown.nativeElement.focus();
      }
    }
  }

  sortOptions() {
    if (this.configData.options.length > 0) {
      if (this.sortAsc) {
        this.configData.options.sort((a, b) => a.displayValue < b.displayValue ? -1 : a.displayValue > b.displayValue ? 1 : 0);
      } else {
        this.configData.options.sort((a, b) => a.displayValue > b.displayValue ? -1 : a.displayValue < b.displayValue ? 1 : 0);
      }
    }
    this.sortAsc = !this.sortAsc;
  }

  positionDrop() {
    const { left, top } = this.options.nativeElement.getBoundingClientRect();
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let elOffsetTop = top + scrollTop;
    let elHeight = this.options.nativeElement.offsetHeight;
    let heightOfDropdown = this.dropdownouter.nativeElement.offsetHeight;
    let mainContentAreaPaddingBottom = 24; //document.getElementsByClassName('main-content-area').style.paddingBottom;
    if ((window.innerHeight - mainContentAreaPaddingBottom) < elOffsetTop + elHeight) {
      this.options.nativeElement.classList.add('ulta');
      this.options.nativeElement.style.top = (7 - elHeight) + "px";
      this.options.nativeElement.style.width = this.dropdownouter.nativeElement.offsetWidth + "px";
    } else {
      this.options.nativeElement.classList.remove('ulta');
      this.options.nativeElement.style.top = (heightOfDropdown - 7) + "px";
      this.options.nativeElement.style.width = this.dropdownouter.nativeElement.offsetWidth + "px";
    }
  }

  focusout(forced?:boolean) {
    this.dropIsClosed = true;
    this.dropdown.nativeElement.classList.remove('focus');
    if(this.dropIcon){
      this.dropIcon.nativeElement.classList.replace('open', 'closed');
    }
    this.dropdown.nativeElement.classList.remove('tab-focus');
    if(forced){
      this.frmGroup.get(this.configData.name).markAsTouched();   
    }
  }

  focusin() {
    if (this.dropdown && this.options && this.options.nativeElement.classList.value.indexOf('hide') > -1) {
      this.dropdown.nativeElement.classList.add('tab-focus');
    }
  }

  sendToSource(event, data = {} ) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.actionType,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: this.frmGroup.get(this.configData.name).value
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  selectedOption(selOpt, selectDefault) {
    if(selectDefault && Array.isArray(selOpt)){
      this.selectedValues = "";
      // let arr = [];
      if(selOpt.length == 1 && selOpt[0] == this.selectAllText){
        this.selectedOption(this.selectAllText, false);
      }else{
        selOpt.forEach(value => {
          this.configData.options.forEach(option => {
            if(option.value == value){
              option["selected"] = true;  
              this.selectedValues += option["displayValue"] + this.comma + " ";
              this.dropdownArrayValue.push(option.value);
            }
          });
        });
      }
      this.selectedValues.replace(/,+/g, ",").trim();
      this.frmGroup.get(this.configData.name).setValue(this.dropdownArrayValue.toString());
      this.droplabel.nativeElement.classList.remove('large');
      this.dropdown.nativeElement.classList.add('filled');
      this.showDropSelect = true;
    }else{
      if(typeof selOpt == 'string' && selOpt.toUpperCase() == this.selectAllText.toUpperCase()){
        this.selectedValues = "";
        this.checkboxAllStatus = !this.checkboxAllStatus;
        this.showDropSelect = this.checkboxAllStatus;
        if (this.checkboxAllStatus) {
          // let arr = [];
          this.configData.options.forEach(option => {
            option["selected"] = this.checkboxAllStatus;
            if(option["selected"]){
              this.selectedValues += option["displayValue"] + this.comma + " ";
              this.dropdownArrayValue.push(option.value);
            }
          });
          this.selectedValues.replace(/,+/g, ",").trim();
          this.frmGroup.get(this.configData.name).setValue(this.dropdownArrayValue.toString());
          this.droplabel.nativeElement.classList.remove('large');
          this.dropdown.nativeElement.classList.add('filled');
        } else {
          // let arr = [];
          this.configData.options.forEach(option => {
            option["selected"] = this.checkboxAllStatus;
          });
          this.dropdownArrayValue.splice(0,this.dropdownArrayValue.length)
          this.selectedValues = this.configData.placeholder;
          this.frmGroup.get(this.configData.name).setValue([]);
          this.droplabel.nativeElement.classList.add('large');
          this.dropdown.nativeElement.classList.remove('filled');  
        }
      } else {
        // selection option is already selected
        if(typeof selOpt == 'object' && selOpt !== this.selectAllText.toUpperCase() && this.selectedValues.indexOf(selOpt["displayValue"]) > -1){
          // removing the selected item
          selOpt['selected'] = false;
          // toggling check box for select all, if checked
          this.checkboxAllStatus = false;
          // let arr = [];
          this.selectedValues = "";
          this.configData.options.forEach(option => {
            if(option["selected"]){
              this.selectedValues += option["displayValue"] + this.comma + " ";
              this.dropdownArrayValue.push(option.value);
            }
          });
          this.selectedValues.replace(/,+/g, ",").trim();
          this.frmGroup.get(this.configData.name).setValue(this.dropdownArrayValue.toString());
          if (this.selectedValues.length == 0) {
            this.dropdown.nativeElement.classList.remove('filled');
            this.showDropSelect = false;
            this.droplabel.nativeElement.classList.add('large');
            this.selectedValues = this.configData.placeholder;
          }
        } else {
          // select the item and check if all items are selected
          selOpt['selected'] = true;
          // let arr = [];
          this.selectedValues = "";
          let count = 0;
          this.dropdownArrayValue.splice(0, this.dropdownArrayValue.length);
          this.configData.options.forEach(option => {
            if(option["selected"]){
              this.selectedValues += option["displayValue"] + this.comma + " ";
              this.dropdownArrayValue.push(option.value);
              count++;
            }
          });
          this.checkboxAllStatus = count == this.configData.options.length ? true : false;
          this.selectedValues.replace(/,+/g, ",").trim();
          this.frmGroup.get(this.configData.name).setValue(this.dropdownArrayValue.toString());
          this.dropdown.nativeElement.classList.add('filled');
          this.droplabel.nativeElement.classList.remove('large');
          this.showDropSelect = true;
        }
      }
      // if (this.configData.sortable) {
      //   if (selOpt !== undefined) {
      //     this.sortIcon.nativeElement.classList.replace('focused', 'default');
      //   } else {
      //     this.sortIcon.nativeElement.classList.replace('focused', 'filled');
      //   }
      // }    
    }
    if (this.frmGroup.get(this.configData.name).valid && this.configData.events) {
      let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'SELECTED_VALUE');
      if (event) {
        this.sendToSource(event, null);
        return
      }
    }
  }

  fieldValueValidation(validations) {
    validations.forEach((validataion: string | any) => {
      let element = (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
          this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
    }, this);
  }
  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden']) {
    this.configData.required = hidden ? !hidden : this.configData.required;
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    this.frmGroup.get(this.configData.name).reset();
    this.frmGroup.get(this.configData.name).updateValueAndValidity();
  }

  @HostListener("window:keydown", ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.dropdown.nativeElement.classList.value.indexOf('tab-focus') > -1
      || this.dropdown.nativeElement.classList.value.indexOf('focus') > -1) {
      const optionsOuter = this.options.nativeElement;
      const options = optionsOuter.children[0].children;
      if (event.key == 'ArrowDown' && this.options.nativeElement.classList.value.indexOf('hide') > -1) {
        this.toggleDrop(event.target);
      } else if (event.key == 'ArrowDown') {
        if (this.focusedOption > -1 && options.length > 0 && this.focusedOption < options.length) {
          options[this.focusedOption].classList.remove('hover')
        }
        this.focusedOption += 1;
        if (this.focusedOption >= options.length) {
          this.focusedOption = options.length - 1;
        }
        if (this.focusedOption < options.length) {
          options[this.focusedOption].classList.add('hover');
          options[this.focusedOption].scrollIntoView({ behavior: "smooth", inline: "nearest" });
        }
      }
      if (event.key == 'ArrowUp' && this.options.nativeElement.classList.value.indexOf('hide') == -1) {
        if (this.focusedOption > 0) {
          options[this.focusedOption].classList.remove('hover')
        }
        this.focusedOption -= 1;
        if (this.focusedOption <= 0) {
          this.focusedOption = 0;
        }
        if (this.focusedOption < options.length && this.focusedOption > -1) {
          options[this.focusedOption].classList.add('hover');
          options[this.focusedOption].scrollIntoView({ behavior: "smooth", inline: "nearest" });
        }
      }
      if (event.key == 'Enter' && this.options.nativeElement.classList.value.indexOf('hide') == -1) {
        this.focusedOption == 0 ? this.selectedOption( this.selectAllText, false) : this.selectedOption( this.configData.options[this.focusedOption - 1], false);
      }
      if (event.key == 'Tab') {
        this.focusout(true);
      }
    }
  }
}
